import { useConfig } from "@/api/hooks/useConfig";
import { NavItemInterface } from "@/components/Sidebar/Sidebar.interface";
import { useTrans } from "@/translations";

import React from "react";
import { NavLink, useParams } from "react-router-dom";

export const NavItem: React.FC<NavItemInterface> = ({ to, name }) => {
  const { t } = useTrans();
  const { client } = useParams();
  const { useClientPath } = useConfig();

  return (
    <NavLink
      to={useClientPath ? `/${client}${to}` : to}
      className={({ isActive }) =>
        `hover:bg-buttery-lime flex h-10 items-center pl-[50px] transition-colors ${
          isActive ? "bg-lime-light" : ""
        }`
      }
      end={to === "/"}
    >
      {t(name)}
    </NavLink>
  );
};
